import { Button, type ButtonProps, useToastContext } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import * as clipboard from 'clipboard-polyfill/text';
import { FC, useEffect, useState } from 'react';

export type TProps = {
  textToCopy: string;
} & Omit<ButtonProps, 'onClick'>;

const CopyTextButton: FC<TProps> = (props) => {
  const { textToCopy, className, variant = 'secondary', ...rest } = props;

  const [isRecentlyCopy, setIsRecentlyCopy] = useState(false);
  const { pushSuccess } = useToastContext();

  useEffect(() => {
    if (!setIsRecentlyCopy) {
      return;
    }

    const timer = setTimeout(() => {
      setIsRecentlyCopy(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [isRecentlyCopy]);

  const handleCopyText = async () => {
    await clipboard.writeText(textToCopy);

    pushSuccess('Copied to clipboard');

    setIsRecentlyCopy(true);
  };

  return (
    <Button
      className={clstx('w-full justify-between', className)}
      onClick={handleCopyText}
      {...({ variant, ...rest } as ButtonProps)}
    >
      {textToCopy}

      <UntitledIcon
        className="h-4 w-4"
        name={isRecentlyCopy ? 'check' : 'copy-07.3'}
      />
    </Button>
  );
};

export default CopyTextButton;
